import {Component, Inject, LOCALE_ID, Renderer2} from '@angular/core';
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";
import {ConfigService} from "../../../services/config.service";

@Component({
  selector: 'app-nowruz-khesht',
  standalone: true,
  imports: [],
  templateUrl: './nowruz-khesht.component.html',
  styleUrl: './nowruz-khesht.component.css'
})
export class NowruzKheshtComponent {

  constructor(public route: Router,
              @Inject(LOCALE_ID) public locale: string,
              public global: GlobalService,
              public conf: ConfigService) {

  }

}
